// eslint-disable-next-line
__webpack_public_path__ = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_CDN_URL || '/')
  : '/';
